import React, { useState } from 'react';
import uploadDocumentIcon from "../../assets/upload-documents-icon.png";
import closeIcon from "../../assets/close-icon.png";
import pdfIcon from "../../assets/pdf.png";
import deleteIcon from "../../assets/delete-icon.png";
import Cookies from 'js-cookie';

const translations = {
  en: {
    addMotivationLetter: "Add Your Motivation Letter",
    motivationDescription: "We analyze your online professional presence to complete your profile and provide richer insights. Don't have a LinkedIn profile? Then you can skip this step, but keep in mind that your personality profile may be incomplete to less complete as a result.",
    uploadFile: "Upload File",
    inputText: "Input Text",
    selectFile: "Select File",
    or: "or",
    dragDrop: "Drag & Drop your file here",
    uploadedFile: "Uploaded File",
    back: "Back",
    next: "Next",
    enterMotivationLetter: "Enter your motivation letter here (minimum 100 words)...",
    wordCount: "Word count:",
    fileSize: {
      bytes: "Bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB"
    },
    alert: "Please upload a PDF file only"
  },
  nl: {
    addMotivationLetter: "Voeg Je Motivatiebrief Toe",
    motivationDescription: "We analyseren je online professionele aanwezigheid om je profiel compleet te maken en rijkere inzichten te bieden. Heb je geen LinkedIn-profiel? Dan kun je deze stap overslaan, maar houd er rekening mee dat je persoonlijkheidsprofiel daardoor mogelijk niet tot minder volledig is.",
    uploadFile: "Bestand Uploaden",
    inputText: "Tekst Invoeren",
    selectFile: "Bestand Kiezen",
    or: "of",
    dragDrop: "Sleep & Plaats je bestand hier",
    uploadedFile: "Geüpload Bestand",
    back: "Terug",
    next: "Volgende",
    enterMotivationLetter: "Voer je motivatiebrief hier in (minimaal 100 woorden)...",
    wordCount: "Aantal woorden:",
    fileSize: {
      bytes: "Bytes",
      kb: "KB",
      mb: "MB",
      gb: "GB"
    },
    alert: "Upload alleen een PDF-bestand"
  }
};

function UploadMotivationLetter({ setActiveIndicator, mLetterfile, setMLetterFile, uploadProgress, setUploadProgress, uploadComplete, setUploadComplete, uploadMLetterUploading, setUploadMLetterUploading, isDragging, setIsDragging, setShowUploadMLetterProgress, uploadMLetterInterval,
  mLetterOption, setMLetterOption, mLetterText, setMLetterText
 }) {

  const isDutch = Cookies.get('isDutch') === 'true';
  const t = translations[isDutch ? 'nl' : 'en'];

  const options = [
    { key: 'uploadFile', label: t.uploadFile },
    { key: 'inputText', label: t.inputText }
  ];

  const formatFileSize = (bytes) => {
    if (bytes === 0) return '0 ' + t.fileSize.bytes;
    const k = 1024;
    const sizes = [t.fileSize.bytes, t.fileSize.kb, t.fileSize.mb, t.fileSize.gb];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };

  const HandleNext = () => {
    setActiveIndicator(3);
    setShowUploadMLetterProgress(false)
  };

  const HandleBack = () => {
    setActiveIndicator(1);
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile && selectedFile.type === 'application/pdf') {
      setMLetterFile(selectedFile);
      startUpload();
    } else {
      alert(t.alert);
    }
  };

  const handleDrop = (event) => {
    event.preventDefault();
    setIsDragging(false);
    const droppedFile = event.dataTransfer.files[0];
    if (droppedFile && droppedFile.type === 'application/pdf') {
      setMLetterFile(droppedFile);
      startUpload();
    } else {
      alert(t.alert);
    }
  };

  const handleDragEnter = (event) => {
    event.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (event) => {
    event.preventDefault();
    setIsDragging(false);
  };

  const startUpload = () => {
    setShowUploadMLetterProgress(true);
    setUploadProgress(0);
    setUploadComplete(false);
    setUploadMLetterUploading(true);
    uploadMLetterInterval = setInterval(() => {
      setUploadProgress((prev) => {
        if (prev >= 100) {
          clearInterval(uploadMLetterInterval);
          setUploadComplete(true);
          setUploadMLetterUploading(false);
          return 100;
        }
        return prev + 20;
      });
    }, 250);
  };

  const cancelUpload = () => {
    clearInterval(uploadMLetterInterval);
    setUploadProgress(0);
    setUploadMLetterUploading(false);
    setMLetterFile(null);
    setUploadComplete(false);
  };

  return (
    <div>
      <div className=' mb-4'>
        <h1 className="text-5xl font-bold mb-4 text-primary">{t.addMotivationLetter}</h1>
        <p className='w-1/2 m-auto'>{t.motivationDescription}</p>
      </div>

      <div className="flex gap-2 justify-center mt-8">
        {options.map((option, index) => (
          <button
            onClick={() => { setMLetterOption(option.key) }}
            key={option.key} className={`w-fit p-2 px-6 border border-gray-300 rounded-full mb-6 ${mLetterOption === option.key && "bg-buttonColor text-white"} `}>{option.label}</button>
        ))}
      </div>

      {mLetterOption === 'uploadFile' ? (
        <div
          className={`border-dashed border-2 border-gray-400 p-8 mb-4 rounded-md ${isDragging ? 'bg-secondary' : 'bg-white'}`}
          onDrop={handleDrop}
          onDragOver={(e) => e.preventDefault()}
          onDragEnter={handleDragEnter}
          onDragLeave={handleDragLeave}
        >
          <input type="file" onChange={handleFileChange} className="hidden" accept=".pdf,application/pdf" />
          <button
            onClick={() => document.querySelector('input[type="file"]').click()}
            className="select-file-button mt-2 py-4 px-6 rounded-md bg-buttonColor flex gap-4 items-center m-auto"
          >
            <img src={uploadDocumentIcon} className='h-6 brightness-0 invert' />
            <p className='text-xl font-bold text-white'>{t.selectFile}</p>
          </button>
          <p className='mt-4 opacity-50'>{t.or}</p>
          <p className='mt-4'>{t.dragDrop}</p>
        </div>
      ) : (
        <div>
          <div className="mb-6">
            <textarea 
              className="w-full p-4 border border-gray-300 rounded-md min-h-[200px] resize-none"
              placeholder={t.enterMotivationLetter}
              value={mLetterText}
              onChange={(e) => setMLetterText(e.target.value)}
              minLength={100}
            ></textarea>
            <p className="text-sm text-gray-500 mt-2">{t.wordCount} {mLetterText.length}/100</p>
          </div>
        </div>
      )}

      {mLetterOption === 'uploadFile' && mLetterfile && uploadComplete && (
        <div className=" rounded-md mb-8 mt-8">
          <h2 className="text-left mb-4 font-bold text-2xl">{t.uploadedFile}</h2>
          <div className="flex items-center justify-between">
            <div className="flex gap-2">
              <img className="size-10" src={pdfIcon} />
              <div className="text-left">
                <p className="font-medium text-gray-900">{mLetterfile.name}</p>
                <p className="text-sm text-gray-500">{formatFileSize(mLetterfile.size)}</p>
              </div>
            </div>
            <span className="cursor-pointer" onClick={cancelUpload}><img className="size-6" src={deleteIcon} /></span>
          </div>
        </div>
      )}

<div className="flex gap-2 mt-4 justify-end">
          <button
            className="py-2 px-4 rounded-md border"
            onClick={HandleBack}
          >
            {t.back}
          </button>
          <button
            className="py-2 px-4 rounded-md bg-buttonColor text-white border"
            onClick={HandleNext}
          >
            {t.next}
          </button>
        </div>
    </div>
  );
}

export default UploadMotivationLetter;